import Notification from './Notification';
export default Notification;


//////////////////
// WEBPACK FOOTER
// /Users/jim/Documents/GitHub/ant-design-pro-site/scaffold/node_modules/_rc-notification@3.1.1@rc-notification/es/index.js
// module id = null
// module chunks = 